import React, { useEffect, useState } from 'react';
import { getPhysiotherapyRequestHistory } from '../../../services/api/cashless-physiotherapy-v2';
import { HistoryItem, TimeContainer } from '../../common/Activities';
import { LoadingContainer, LoadingIcon } from '../../offline-consultations/table-subcomponent/StyledComponents';
import { StyledHistoryContiner } from '../styled-elements';

const HistoryContainer = ({
    requestId,
    type
}) => {

    const [history, setHistory] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (!requestId) {
            return
        }
            getPhysiotherapyRequestHistory(requestId)
            .then((response) => {
                if (response && response.message === 'success') {
                    setHistory(response.data)
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
    }, [requestId])
    
    return (
        isLoading ? (
            <LoadingContainer>
                <LoadingIcon />
            </LoadingContainer>
        ) : (
            <StyledHistoryContiner>
                {(history && history.length) ? (
                    history.map(item => (
                        <HistoryItem key={item.activityId}>
                            {item.description} by {item.userName} 
                            {item.meta || ''} 
                            {item.audioFileLink ? 
                                <a href={item.audioFileLink} target="_blank" rel="noopener noreferrer"> (Link)</a> : 
                            <></>}
                            <TimeContainer>{item.eventTime}</TimeContainer>
                        </HistoryItem>
                    ))
                ) : (<HistoryItem>No Activities here...</HistoryItem>)}
            </StyledHistoryContiner>
        )
    )
}

export default HistoryContainer